import { type CheckboxSize } from "ui/checkbox/checkbox.types";

/** The MUI size each Apollo size renders at — the names the `MuiCheckbox` theme entry is keyed on. */
export const CHECKBOX_MUI_SIZE = {
  xs: "xsmall",
  sm: "small",
  md: "medium",
} as const satisfies Record<CheckboxSize, string>;

/**
 * `gap` is in spacing steps and is the whole box-to-text distance, because the theme negates the halo's
 * padding: Figma's `container/p` plus the row's 4px — 8 + 4 at md, 6 + 4 at sm, 4 + 4 at xs.
 */
export const CHECKBOX_LABEL = {
  xs: { gap: 1, variant: "caption" },
  sm: { gap: 1.25, variant: "body2" },
  md: { gap: 1.5, variant: "body1" },
} as const satisfies Record<CheckboxSize, { gap: number; variant: "body1" | "body2" | "caption" }>;
